var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#DDE1FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 52.0678C21.4344 52.0678 12.4321 43.0655 12.4321 32C12.4321 20.9345 21.4344 11.9322 32.4999 11.9322C43.5654 11.9322 52.5677 20.9345 52.5677 32C52.5677 43.0655 43.5654 52.0678 32.4999 52.0678Z",
    fill: "#98A3FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5003 12.4746C43.2664 12.4746 52.0257 21.2339 52.0257 32C52.0257 42.7661 43.2664 51.5254 32.5003 51.5254C21.7342 51.5254 12.9749 42.7661 12.9749 32C12.9749 21.2339 21.7342 12.4746 32.5003 12.4746ZM32.5003 11.3898C21.1181 11.3898 11.8901 20.6178 11.8901 32C11.8901 43.3822 21.1181 52.6102 32.5003 52.6102C43.8825 52.6102 53.1105 43.3822 53.1105 32C53.1105 20.6178 43.8825 11.3898 32.5003 11.3898Z",
    fill: "#4756D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7373 32L29.2458 38.5085L43.3475 24.4068",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecheck);
export default __webpack_public_path__ + "static/media/bluecheck.c34bd2c8.svg";
export { ForwardRef as ReactComponent };